module.exports = __webpack_public_path__ + "img/veriban2025.7214c470.png";